import { ValueGetterParams } from 'ag-grid-community';

const dayPricePercentGetter = (
  params: ValueGetterParams, // new price
  comparisonDayPrice: number | null | undefined, // old price
) => {
  const dayPrice = params.data?.dayPrice;

  const comparisonDayPricePercent =
    comparisonDayPrice && dayPrice
      ? (
          ((dayPrice - comparisonDayPrice) / comparisonDayPrice) *
          100
        ).toFixed(2)
      : null;

  return comparisonDayPricePercent;
};

export default dayPricePercentGetter;
